export const MASONRY_MIN_COL_WIDTH = 260;
export const MASONRY_BREAKPOINT = 641;
export const MASONRY_ROW_UNIT = 8;
export const MASONRY_GAP_PX = 20;

/**
 * @param {number} width
 * @param {number} [minColWidth]
 * @param {number} [gapPx] column gap. 0 keeps floor(width / minColWidth).
 * @returns {number}
 */
export function masonryColumnCount(width, minColWidth = MASONRY_MIN_COL_WIDTH, gapPx = 0) {
  if (!width || width <= 0) return 2;
  const min = Math.max(1, Number(minColWidth) || 1);
  const gap = Math.max(0, Number(gapPx) || 0);
  return Math.max(2, Math.floor((width + gap) / (min + gap)));
}

/**
 * Round-robin CSS grid tracks: item i → column (i % N).
 * Shorter cards do not push the next item in that column down past other columns.
 *
 * @param {number[]} heights pixel heights
 * @param {number} columnCount
 * @param {number} [rowUnit]
 * @param {number} [gapPx]
 * @returns {Array<{ column: number, rowStart: number, rowSpan: number }>}
 */
export function assignRoundRobinGridTracks(
  heights,
  columnCount,
  rowUnit = MASONRY_ROW_UNIT,
  gapPx = MASONRY_GAP_PX
) {
  const cols = Math.max(1, Math.floor(Number(columnCount) || 1));
  const unit = Math.max(1, Number(rowUnit) || 1);
  const gapRows = Math.max(0, Math.round((Number(gapPx) || 0) / unit));
  const colUsed = Array.from({ length: cols }, () => 0);
  const list = Array.isArray(heights) ? heights : [];

  return list.map((rawHeight, index) => {
    const column = (index % cols) + 1;
    const colIdx = column - 1;
    const rowSpan = Math.max(1, Math.ceil(Math.max(0, Number(rawHeight) || 0) / unit));
    const rowStart = colUsed[colIdx] + 1;
    colUsed[colIdx] += rowSpan + gapRows;
    return { column, rowStart, rowSpan };
  });
}

/**
 * Row where a full-width footer (SHOW MORE) should start, after every column.
 * @param {Array<{ rowStart: number, rowSpan: number }>} tracks
 * @param {number} [rowUnit]
 * @param {number} [gapPx]
 * @returns {number}
 */
export function masonryFooterRowStart(
  tracks,
  rowUnit = MASONRY_ROW_UNIT,
  gapPx = MASONRY_GAP_PX
) {
  const unit = Math.max(1, Number(rowUnit) || 1);
  const gapRows = Math.max(0, Math.round((Number(gapPx) || 0) / unit));
  let maxEnd = 1;
  (tracks || []).forEach((track) => {
    const end = (track.rowStart || 1) + (track.rowSpan || 1);
    if (end > maxEnd) maxEnd = end;
  });
  return maxEnd + gapRows;
}
